module.exports = __webpack_public_path__ + "static/media/tokensets.b4a20b58.svg";